import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService, ModalService, SettingsService, MarathonService } from '../_services';
import { environment } from '../../environments/environment';

declare var jquery: any;
declare var $: any;
declare var alertify: any;

@Component({
    templateUrl: 'student_user_list2.component.html',
    styleUrls: ['student_user_list2.component.css']
})
export class StudentUserList2Component implements OnInit {
    loading = false;
    cur_page = 1;
    from = 0;
    pageSize = 10;
    totalPages = 10;
    totalcount: any;
    search_txt = '';
    enrollment_Number = '';
    student_list = [];
    fetch_enrollment_id = '';
    fetching = false;

    filter_fields = [
        { value: 'enrollment_Number', name: 'Enrollment No.' },
        { value: 'search', name: 'Name / Email' },
        { value: 'institution_id', name: 'Institution ID' },
        { value: 'course_id', name: 'Course ID' },
        { value: 'branch_id', name: 'Branch ID' },
        { value: 'semester', name: 'Semester' },
        { value: 'year', name: 'Year' },
    ];
    filter_field = 'enrollment_Number';
    filter_value = '';

    institution_id = '';
    course_id = '';
    branch_id = '';
    semester = '';
    year = '';
    fromDate = '';
    toDate = '';

    edit_name = '';
    edit_enrollment_Number = '';
    edit_semester = '';
    edit_year = '';
    saving = false;

    roleId = localStorage.getItem(`${environment.appName}` + '_role');

    constructor(
        private setting: SettingsService,
        private authenticationService: AuthenticationService,
        private modalService: ModalService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private _marathon: MarathonService,
        private router: Router) { }

    ngOnInit() {
        this.refresh();
    }

    refresh() {
        this.loading = true;
        this._marathon.getStudentList2(
            this.cur_page,
            this.enrollment_Number,
            this.search_txt,
            this.institution_id,
            this.course_id,
            this.branch_id,
            this.semester,
            this.year,
            this.fromDate,
            this.toDate,
        ).subscribe(data => {
            this.loading = false;
            this.student_list = data.data.docs;
            this.totalcount = data.data.totalDocs;
            this.from = data.data.pagingCounter;
            this.cur_page = data.data.page;
            this.totalPages = data.data.totalPages;
        }, error => {
            this.loading = false;
        });
    }

    // Only one search field is ever active at a time - whichever is picked
    // in the "Search By" dropdown. This clears all of them before applying
    // the one currently selected.
    clearFilterFields() {
        this.search_txt = '';
        this.enrollment_Number = '';
        this.institution_id = '';
        this.course_id = '';
        this.branch_id = '';
        this.semester = '';
        this.year = '';
    }

    search(e) {
        e.stopPropagation();
        this.filter_value = e.target.value;
        this.clearFilterFields();
        if (this.filter_field) {
            this[this.filter_field] = this.filter_value;
        }
        this.changePage(1);
    }

    onFilterFieldChange(e) {
        this.filter_field = e.target.value;
        this.filter_value = '';
        $('#searchValue').val('');
        this.clearFilterFields();
        this.changePage(1);
    }

    changePage(page) {
        this.cur_page = page;
        this.refresh();
    }

    resetFilter(e) {
        this.filter_field = 'enrollment_Number';
        this.filter_value = '';
        this.fromDate = '';
        this.toDate = '';
        this.clearFilterFields();
        $('#searchValue').val('');
        $('#fromDate').val('');
        $('#toDate').val('');
        this.changePage(1);
    }

    onFromDateChange(e) {
        e.stopPropagation();

        if (!this.fromDate) {
            // From Date cleared - clear To Date too since it's no longer mandatory.
            this.toDate = '';
            $('#toDate').val('');
            this.changePage(1);
            return;
        }

        if (this.toDate && this.toDate < this.fromDate) {
            this.toDate = '';
            $('#toDate').val('');
            this.toastr.error('To Date cannot be earlier than From Date');
        }

        if (!this.toDate) {
            // Wait for To Date before querying - it's mandatory once From Date is set.
            this.toastr.error('Please select To Date');
            return;
        }

        this.changePage(1);
    }

    onToDateChange(e) {
        e.stopPropagation();

        if (!this.fromDate) {
            this.toDate = '';
            $('#toDate').val('');
            this.toastr.error('Please select From Date first');
            return;
        }

        if (this.toDate && this.toDate < this.fromDate) {
            this.toDate = '';
            $('#toDate').val('');
            this.toastr.error('To Date cannot be earlier than From Date');
            return;
        }

        this.changePage(1);
    }

    fetchUser(e) {
        e.stopPropagation();
        if (!this.fetch_enrollment_id) {
            this.toastr.error('Please enter Enrollment ID');
            return;
        }
        var that = this;
        this.fetching = true;
        this._marathon.fetchSmiUser(this.fetch_enrollment_id).subscribe(data => {
            that.fetching = false;
            that.toastr.success(data && data.status && data.status.message ? data.status.message : 'User fetched successfully');

            // Load the fetched enrollment number straight into the table filter
            // so the user immediately sees the record without searching again.
            that.clearFilterFields();
            that.filter_field = 'enrollment_Number';
            that.filter_value = that.fetch_enrollment_id;
            that.enrollment_Number = that.fetch_enrollment_id;
            $('#searchValue').val(that.fetch_enrollment_id);
            that.changePage(1);
        }, error => {
            that.fetching = false;
            that.toastr.error('Failed to fetch user');
        });
    }

    openEdit(e, list) {
        e.stopPropagation();
        this.edit_name = list && list.name ? list.name : '';
        this.edit_enrollment_Number = list && list.enrollment_Number ? list.enrollment_Number : '';
        this.edit_semester = list && list.semester ? list.semester : '';
        this.edit_year = list && list.year ? list.year : '';
        $('#editUserModal').modal('show');
    }

    closeEdit(e) {
        e.stopPropagation();
        $('#editUserModal').modal('hide');
    }

    saveEdit(e) {
        e.stopPropagation();
        if (!this.edit_enrollment_Number) {
            this.toastr.error('Enrollment Number is required');
            return;
        }
        var that = this;
        this.saving = true;
        this._marathon.editSmiUser(this.edit_enrollment_Number, this.edit_semester, this.edit_year).subscribe(data => {
            that.saving = false;
            that.toastr.success(data && data.status && data.status.message ? data.status.message : 'User updated successfully');
            $('#editUserModal').modal('hide');
            that.refresh();
        }, error => {
            that.saving = false;
            that.toastr.error('Failed to update user');
        });
    }
}
